<template>
  <div id="calculator" class="staking-calculator fr-container">
    <img src="../../../assets/images/vectors.png" class="background-image" alt="">
    <h2 class="header">See what you could be earning</h2>
    <div class="staking-content">
      <div class="content-container">
        <div class="left-content">
          <span class="left-header">DFort is our inside stable coin</span>
          <div class="input-container">
            <span class="title">How much?</span>
            <div class="input-contain">
              <span class="sign">$</span>
              <input type="number" min="10000" @change="onChange" v-model="value" class="input">
            </div>
          </div>
          <div class="input-container">
            <span class="title">Which crypto?</span>
            <div class="input-contain">
              <img src="../../../assets/images/fortchain_token.png" class="image" alt="">
              <input type="text" value="DFORT" disabled class="input">
            </div>
          </div>
          <div class="input-container">
            <span class="title">How long?</span>
            <md-field>
              <md-select v-model="activeDuration" name="movie" id="movie">
                <md-option v-for="item in durations"
                           :key="item.value"
                           :value="item.value">{{ item.title }}
                </md-option>
              </md-select>
            </md-field>
          </div>
        </div>
        <div class="right-content">
          <span class="title">Earning with FortChain</span>
          <span class="price up">${{ earning }}</span>
          <div class="down-content">
            <span class="title">APR</span>
            <span class="price">{{ activeApr }}</span>
            <!--            <span class="title">You can get rewards every month</span>-->
          </div>
          <registration-buttons :hide="1"/>
          <span class="about">
            This calculator is for information and reference purposes only.
            Rewards are calculated monthly and may change from time to time,
            and the rates presented above are not guaranteed for the duration of the above term.
        </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RegistrationButtons from '../../shared/RegistrationButtons'

export default {
  data() {
    return {
      value: 10000,
      activeDuration: 1,
      durations: [
        {
          title: '1 Year',
          value: 1,
        },
        {
          title: '6 Month',
          value: .5,
        },
      ],
    }
  },
  components: {
    RegistrationButtons
  },
  computed: {
    earning() {
      let apr = this.activeDuration === 1 ? 25 : 20

      return Number(this.value) + Number(this.value) * apr * this.activeDuration / 100
    },
    activeApr() {
      return this.activeDuration === 1 ? '25%-35%' : '20%-30%'
    }
  },
  methods: {
    onChange() {
      if (this.value < 10000) this.value = 10000;
    }
  }
}
</script>

<style lang="scss" scoped>
.staking-calculator {
  padding-top: 75px;
  padding-bottom: 300px;
  width: 100%;
  background: linear-gradient(109.04deg, #02000E 0.52%, #090D23 62.82%, #2C4C8A 90.85%);
  color: white;
  position: relative;
  @media only screen and (max-width: 1365px) and (min-width: 1024px) {
    padding-top: 55px;
    padding-bottom: 80px;
  }
  @media only screen and (max-width: 1023px) {
    padding-bottom: 30px;
    background: #070A1E;
    padding-top: 30px;
  }

  .header {
    color: white;
    font-style: normal;
    font-weight: normal;
    font-size: 40px;
    line-height: 70px;
    position: relative;
    margin: 0 auto 20px;
    display: block;
    @media only screen and (max-width: 1023px) {
      font-size: 20px;
      line-height: 30px;
    }
  }

  .staking-content {
    //border: 1px solid white;
    border-radius: 10px;
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .background-image {
    position: absolute;
    left: 3%;
    top: 115px;
    pointer-events: none;
    height: 70%;
    @media only screen and (max-width: 1023px) {
      display: none;
    }
  }

  .content-container {
    width: 100%;
    @include space-between;
    align-items: flex-start;
    @media only screen and (max-width: 1023px) {
      flex-direction: column;
    }

    .left-content {
      width: 55%;
      padding: 40px;
      border-radius: 10px 0 0 10px;
      @media only screen and (max-width: 1365px) and (min-width: 1024px) {
        padding: 20px;
      }
      @media only screen and (max-width: 1023px) {
        width: 100%;
        padding: 0;
      }

      .left-header {
        display: block;
        font-size: 18px;
        @media only screen and (max-width: 1023px) {
          font-size: 15px;
        }
      }

      ::v-deep .input-container {
        margin-top: 30px;

        &:nth-of-type(1) {
          margin-top: 40px;
          @media only screen and (max-width: 1023px) {
            margin-top: 20px;
          }

          .input {
            width: 70%;
            padding-left: 25px;
            @media only screen and (max-width: 1023px) {
              width: 100%;
            }
          }
        }

        &:nth-of-type(2) {
          .input {
            font-weight: bold;
            letter-spacing: 1.5px;
          }
        }

        .input-contain {
          position: relative;

          .sign {
            position: absolute;
            left: 10px;
            color: $base-color;
            font-size: 18px;
            font-weight: bold;
            top: 50%;
            transform: translateY(-50%);
          }

          .image {
            position: absolute;
            width: 40px;
            height: 40px;
            margin-right: 0;
            border-radius: 50%;
            top: 50%;
            left: 10px;
            transform: translateY(-50%);
          }
        }

        .title {
          display: block;
          font-size: 18px;
          margin-bottom: 16px;
          font-style: normal;
          font-weight: 500;
          @media only screen and (max-width: 1365px) and (min-width: 1024px) {
            font-size: 16px;
          }
        }

        .input {
          background: rgba(7, 10, 29, 0.67);
          border: 1px solid rgba(255, 255, 255, 0.3);
          box-sizing: border-box;
          border-radius: 45px;
          height: 50px;
          width: 239px;
          font-size: 18px;
          color: #FFFFFF;
          padding-left: 60px;
          @media only screen and (max-width: 1023px) {
            width: 100%;
          }
        }

        .md-field {
          width: 239px;
          margin: 0;
          padding: 0;
          @media only screen and (max-width: 1023px) {
            width: 100%;
          }

          &:after, &:before {
            display: none;
          }
        }

        .md-select {
          border: 1px solid rgba(255, 255, 255, 0.3);
          box-sizing: border-box;
          border-radius: 45px;
          height: 50px;
          background: rgba(7, 10, 29, 0.67);

          .md-icon {
            margin-right: 10px;

            svg {
              fill: white;
            }
          }

          .md-input {
            background: transparent;
            font-size: 18px;
            width: 100%;
            color: #FFFFFF;
            -webkit-text-fill-color: #FFFFFF;
            height: 100%;
            padding-left: 20px;
            outline: none !important;
          }
        }
      }
    }

    .right-content {
      width: 45%;
      padding: 40px;
      border-radius: 0 10px 10px 0;
      background: linear-gradient(324.23deg, rgba(61, 95, 162, 0.14) 5.1%, rgba(29, 34, 86, 0.14) 83.91%);
      //display: flex;
      //flex-direction: column;
      //align-items: center;
      @media only screen and (max-width: 1365px) and (min-width: 1024px) {
        padding: 20px;
      }
      @media only screen and (max-width: 1023px) {
        width: 100%;
        padding: 30px 0;
        background: transparent;
      }

      .title {
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        //text-align: center;
        @media only screen and (max-width: 1365px) and (min-width: 1024px) {
          font-size: 16px;
        }
      }

      .price {
        font-style: normal;
        font-weight: normal;
        font-size: 60px;
        //text-align: center;
        display: block;

        &.up {
          margin-top: 10px;
        }

        @media only screen and (max-width: 1365px) and (min-width: 1024px) {
          font-size: 40px;
        }
        @media only screen and (max-width: 1023px)  {
          font-size: 35px;
        }
      }

      .down-content {
        //display: flex;
        //flex-direction: column;
        //align-items: center;
        margin-top: 35px;

        .price {
          margin: 5px 0 10px;
        }

        .title {
          font-size: 16px;
        }
      }

      ::v-deep .registration-button {
        margin-top: 40px;

        .button {
          margin-left: 0;
        }
      }

      .about {
        padding-bottom: 120px;
        font-weight: 300;
        font-size: 13px;
        line-height: 16px;
        width: 100%;
        margin-top: 31px;
        @media only screen and (max-width: 1023px) {
          padding-bottom: 0;
        }
      }
    }
  }
}
</style>